export default {
  titleBar: '0px 6px 6px rgba(0, 0, 0, 0.08)',
  card: '0px 3px 5px rgba(0, 0, 0, 0.25)',
  stepButton: '0px 12px 15px rgba(0, 0, 0, 0.25)',
}
